import React from 'react';
import { Button } from '@/components/ui/button';
import { BarChart3, Download } from 'lucide-react';
import { useAnalytics } from './Analytics/useAnalytics';
import PaymentStatsOverview from './Analytics/PaymentStatsOverview';
import AnalyticsFilters from './Analytics/AnalyticsFilters';
import SummaryStatsGrid from './Analytics/SummaryStatsGrid';
import ExportInstructionsCard from './Analytics/ExportInstructionsCard';
import PocketReconciliationCard from './Analytics/PocketReconciliationCard';
import AuthBreakdownCard from './Analytics/AuthBreakdownCard';

export default function Analytics() {
  const {
    summary, locations, paymentStats, loading, exporting, authBreakdown,
    dateFrom, setDateFrom, dateTo, setDateTo, locationFilter, setLocationFilter,
    statusFilter, setStatusFilter,
    pocketDateFrom, setPocketDateFrom, pocketDateTo, setPocketDateTo, exportingPocket,
    handleExport, applyFilters, clearFilters, handleExportPocketReconciliation,
  } = useAnalytics();

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <BarChart3 className="w-8 h-8 text-primary" />
          <h1 className="text-4xl font-black font-heading uppercase">Analytics & Reports</h1>
        </div>
        <Button
          onClick={handleExport}
          disabled={exporting}
          className="btn-volt gap-2"
          data-testid="export-button"
        >
          <Download className="w-4 h-4" />
          {exporting ? 'Exporting...' : 'Export to Excel'}
        </Button>
      </div>

      {paymentStats && (
        <PaymentStatsOverview paymentStats={paymentStats} totalRevenue={summary?.total_revenue} />
      )}

      <AnalyticsFilters
        dateFrom={dateFrom} setDateFrom={setDateFrom}
        dateTo={dateTo} setDateTo={setDateTo}
        locationFilter={locationFilter} setLocationFilter={setLocationFilter}
        statusFilter={statusFilter} setStatusFilter={setStatusFilter}
        locations={locations}
        onApply={applyFilters}
        onClear={clearFilters}
      />

      {loading ? (
        <div className="text-center py-12 text-muted-foreground">Loading analytics...</div>
      ) : summary && (
        <SummaryStatsGrid summary={summary} />
      )}

      <ExportInstructionsCard />

      <PocketReconciliationCard
        pocketDateFrom={pocketDateFrom} setPocketDateFrom={setPocketDateFrom}
        pocketDateTo={pocketDateTo} setPocketDateTo={setPocketDateTo}
        exportingPocket={exportingPocket}
        onExport={handleExportPocketReconciliation}
      />

      <AuthBreakdownCard authBreakdown={authBreakdown} />
    </div>
  );
}
